import { createDevicePolicy, createDevicePolicyPrice } from '@/ducks/devicePolicyReducer'
import { get, post } from '@/util/auth'

import { API_ROUTE_DEVICE_POLICY_PRICES, API_ROUTE_DEVICE_POLICY_PRICE } from './apiRoutes'

export const getDevicePolicyPricesAPI = async () => {
  const response = await get(API_ROUTE_DEVICE_POLICY_PRICES)

  return {
    prices: transformPricesFromWS(response),
    devicePolicies: transformDevicePoliciesFromWS(response),
  }
}

const transformPricesFromWS = (items: any) => items.map(transformPriceFromWs)

const transformPriceFromWs = (item: any) =>
  createDevicePolicyPrice({
    ...item,
    customerId: item.customer_id,
    policyId: item.policy_id,
    policyName: item.policy_name,
    customerName: item.customer_name,
    price: parseFloat(item.price).toFixed(2),
  })

const transformDevicePoliciesFromWS = (prices: any) => {
  const result = []
  const map = new Map()

  for (const price of prices) {
    if (!map.has(price.policy_id)) {
      map.set(price.policy_id, true) // set any value to Map
      result.push(
        createDevicePolicy({
          id: price.policy_id,
          name: price.policy_name,
          customerName: price.customer_name,
        })
      )
    }
  }
  return result
}

export const postNewPriceAPI = async ({ id, price }: { id: number; price: string }) => {
  const payload = {
    price: parseFloat(price),
  }

  const response = await post(
    API_ROUTE_DEVICE_POLICY_PRICE.replace(':priceId', String(id)),
    payload
  )

  return transformPriceFromWs(response)
}
